import { mq } from '@styles/vars/media-queries.style'
import { font } from '@styles/vars/font.style'
import { TextBody } from '@styles/vars/textStyles.style'
import { clamp } from '@styles/utils/conversion.style'
import styled from 'styled-components'


export const HeroMain = styled.section`
  background: ${props => props.background};
  color: ${props => props.color};
  ${clamp('padding-top', 140, 150)}
  ${clamp('padding-bottom', 40, 60)}
`

export const MainBox = styled.div`
  ${mq.tabletL} {
    display: grid;
    grid-gap: 30px;
    grid-template-columns: repeat(12, 1fr);
    align-items: center;
  }
`

export const HeroTitle = styled.div`
  max-width: 66rem;
  margin-bottom: 20px;
  ${mq.tabletL} {
    grid-column: span 7;
  }
  ${TextBody} {
    font-family: ${font.serif.family};
    ${clamp('font-size', 28, 68)}
    font-weight: ${font.serif.weight.light};
    line-height: 1.2;
    letter-spacing: -0.01em;

    strong {
      font-family: ${font.sans.family};
      font-weight: ${font.sans.weight.extrabold};
    }
  }
`

export const HeroImage = styled.div`
  ${mq.tabletL} {
    grid-column: span 5;
  }
`

export const HeroSubTitleContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: end;
  h3 {
    font-family: ${font.sans.family};
  }
  ${mq.tabletLMax} {
    margin-top: 30px;
  }
`

export const HeroSubTitle = styled.div`
  display: flex;
  align-items: center;
  
  span {
    font-family: ${font.sans.family};
    font-weight: normal;
    line-height: 37px;
    max-width: 420px;
    text-transform: none;
    ${clamp('font-size', 22, 32)};
  }
`

export const LogoContainer = styled.div`
  ${clamp('width', 118, 150)}
  margin-right: 10px;
`